import { defineComponent as F, ref as d, computed as f, watch as K, openBlock as r, createElementBlock as u, createElementVNode as c, normalizeClass as n, createVNode as m, withCtx as T, unref as y, Fragment as L, renderList as M, withDirectives as E, withKeys as h, withModifiers as V, createBlock as W, resolveDynamicComponent as A, createCommentVNode as g, toDisplayString as B, renderSlot as j } from "vue";
import { ChevronLeftIcon as q, ChevronRightIcon as G } from "@frontiers/brink-icons";
import { SlidingPanel as H } from "./slidingPanel.es.js";
import { T as J } from "./chunks/Tooltip.b53afcfb.js";
import './assets/index36.css';const Q = { class: "Tabs" }, U = ["data-tooltip-placement", "id", "aria-label", "aria-selected", "tabindex", "disabled", "onClick", "onKeydown", "onFocus"], X = {
  key: 0,
  class: "Tabs__icon"
}, te = /* @__PURE__ */ F({
  __name: "Tabs",
  props: {
    tabs: { default: () => new Array() },
    size: { default: "md" },
    iconOnly: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: { default: 0 },
    hideDivider: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(D, { emit: R }) {
    const s = D, o = d(s.modelValue), $ = d([]), _ = d([]), z = d(null), S = {
      sm: "md",
      md: "md",
      lg: "lg"
    }, O = f(() => S[s.size]), C = f(() => s.tabs.map((e, t) => ({
      ...e,
      id: `${e.label}-${t}`
    }))), P = f(() => C.value[o.value].id);
    K(() => s.modelValue, b);
    function k(e) {
      let t = o.value;
      do
        e === "right" ? t = (t + 1) % s.tabs.length : t > 0 ? t-- : t = s.tabs.length - 1;
      while (s.tabs[t].disabled || t === o.value);
      b(t);
    }
    function b(e) {
      var a, l, i, w;
      if (o.value === e)
        return;
      R("update:modelValue", e), o.value = e;
      const t = (a = $.value) == null ? void 0 : a[o.value];
      t == null || t.focus(), (l = z.value) == null || l.scrollElementIntoView(t), (w = (i = s.tabs[e]).onClick) == null || w.call(i);
    }
    function v(e) {
      return (s.iconOnly || s.tabs[e].iconOnly) && !!s.tabs[e].iconComponent;
    }
    function I(e) {
      p(), v(e) && (_.value[e] = !0);
    }
    function p() {
      _.value.fill(!1, 0);
    }
    function N(e) {
      return e === 0 ? ["top", "right"] : e === s.tabs.length - 1 ? ["top", "left"] : ["top", "center"];
    }
    return (e, t) => (r(), u("div", Q, [
      c("div", {
        class: n(["Tabs__scrollWrapper", `Tabs__scrollWrapper--${e.size}`])
      }, [
        m(H, {
          ref_key: "slidingPanelRef",
          ref: z,
          class: "Tabs__slidingPanel"
        }, {
          "button-left": T(() => [
            c("div", {
              class: n(["Tabs__button", `Tabs__button--${e.size}`])
            }, [
              m(y(q))
            ], 2)
          ]),
          "button-right": T(() => [
            c("div", {
              class: n(["Tabs__button", `Tabs__button--${e.size}`])
            }, [
              m(y(G))
            ], 2)
          ]),
          default: T(() => [
            c("div", {
              ref: "tablistRef",
              role: "tablist",
              class: n(["Tabs__tablist", [
                `Tabs__tablist--${e.size}`,
                {
                  "Tabs__tablist--addDivider": !e.hideDivider
                }
              ]])
            }, [
              (r(!0), u(L, null, M(C.value, (a, l) => E((r(), u("button", {
                key: a.id,
                "data-tooltip-placement": N(l),
                id: a.id,
                ref_for: !0,
                ref_key: "tabsRef",
                ref: $,
                class: n(["Tabs__tab", [
                  `Tabs__tab--${e.size}`,
                  { "Tabs__tab--active": o.value === l },
                  { "Tabs__tab--iconOnly": v(l) }
                ]]),
                role: "tab",
                "aria-label": a.label,
                "aria-selected": o.value === l,
                tabindex: o.value === l ? 0 : -1,
                disabled: a.disabled || e.disabled,
                onClick: (i) => b(l),
                onKeydown: [
                  t[0] || (t[0] = h(V((i) => k("right"), ["prevent"]), ["right"])),
                  t[1] || (t[1] = h(V((i) => k("left"), ["prevent"]), ["left"])),
                  h((i) => b(l), ["enter"])
                ],
                onFocus: (i) => I(l),
                onBlur: p,
                onMouseleave: p
              }, [
                c("div", {
                  class: n(["Tabs__title", {
                    "Tabs__title--active": o.value === l
                  }])
                }, [
                  a.iconComponent ? (r(), u("div", X, [
                    (r(), W(A(a.iconComponent), {
                      fill: "currentColor",
                      size: O.value
                    }, null, 8, ["size"]))
                  ])) : g("", !0),
                  v(l) ? g("", !0) : (r(), u("span", {
                    key: 1,
                    class: n(["Tabs__label", [
                      `Tabs__label--${e.size}`,
                      { "Tabs__label--active": o.value === l }
                    ]])
                  }, B(a.label), 3)),
                  a.counter ? (r(), u("span", {
                    key: 2,
                    class: n(["Tabs__counter", {
                      "Tabs__counter--active": o.value === l
                    }])
                  }, B(a.counter), 3)) : g("", !0)
                ], 2)
              ], 42, U)), [
                [y(J), _.value[l] ? a.label : ""]
              ])), 128))
            ], 2)
          ]),
          _: 1
        }, 512)
      ], 2),
      j(e.$slots, "panel", {
        "aria-Labelledby": P.value,
        role: "tabpanel",
        tabindex: "0"
      })
    ]));
  }
});
export {
  te as Tabs
};
